/**
 * @ignore
 */
class BufferDragTool {
    constructor(opts) {
        this.options = opts || {};
        this.params = null;
        //
        this.symbol = null;
        this.defaultSymbol = null;
        this.points = [];
        this.movingPoint = null;
        this.drawing = false;
    }

    /**
     * @ignore
     * @param {*} opts 
     * @param {*} opts.layer
     * @param {*} opts.symbol
     * @param {*} opts.callback
     * @param {*} opts.context
     */
    onClick(opts) {
        this.params = opts;
        this.options.map.setCursor('crosshair');
        //
        if (opts.symbol) {
            this.symbol = G.utils.RenderUtil.object2Symbol(opts.symbol);
        } else {
            this.symbol = this.defaultSymbol;
        }
        this.points = [];
        this.movingPoint = null;
        this.drawing = true;
        this.options.map.stopDbClick();
    }

    deactivate() {
        this.params = null;
        this.options.map.setCursor('');
        this.symbol = null;
        this.points = [];
        this.movingPoint = null;
        this.drawing = false;
        this.options.map.resumeDbClick();
    }

    onMouseDown(button, shift, screenx, screeny, mapx, mapy, handled) {
    }

    onMouseUp(button, shift, screenx, screeny, mapx, mapy, handled) {
    }

    onMouseMove(button, shift, screenx, screeny, mapx, mapy, handled) {
    }

    onMouseClick(button, shift, screenx, screeny, mapx, mapy, handled) {
    }

    onDblclick(button, shift, screenx, screeny, mapx, mapy, handled) {
    }
}
module.exports = BufferDragTool;